<template>
  <div>
    <h3>You Must Accept Our Terms of Service</h3>
    <button class="btn btn-primary" v-on:click="authenticate">Accept Terms</button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions([
      'unauthenticatedLogin'
    ]),
    async authenticate () {
      try {
        await this.unauthenticatedLogin()
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/homeSearch/rightSide/Terms.vue